import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import PropTypes from 'prop-types'
import * as storage from '@utils/storage'
import i18next from 'i18next'
import { IsEnglish } from '@utils/language';
import { getAllListsPage } from '@actionsSup/approvalCentral';
import { approvalType } from '@scripts/CentralApprovalTypeHelper';
import { centralApprovalStatus } from '@scripts/CentralApprovalStatusHelper';
import { absenceCalendarStatus } from '@scripts/AbsenceCalendarStatusHelper';
import * as pageSourceCode from '@scripts/PageSourceCode';
import styles from '@styles/approvalCentral.module.css'

const useStyles = makeStyles(theme => ({
    toolBar: {
        alignSelf: 'flex-end',
        color: "var(--color1) !important"
    },
    buttonFilter: {
        marginTop: '10px',
        border: '1px solid red'
    },
    appBar: {
        boxShadow: 'none !important'
    },
    pending: {
        backgroundColor: '#3a8bd8',
        color: 'white',
        borderRadius: '10px',
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    approved: {
        backgroundColor: '#3ba96a',
        color: 'white',
        borderRadius: '10px',
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    refused: {
        backgroundColor: '#ff7663',
        color: 'white',
        borderRadius: '10px',
        paddingRight: '5px',
        paddingLeft: '5px'
    }
}));

function FilterRequest(props) {
    const classes = useStyles();

    const {
        pageSource,
        handleFilter,
    } = props;

    const [open, setOpen] = useState(false);
    const [listFilter, setListFilter] = useState([]);
    const [typeRequest, setTypeRequest] = useState({
        vacation: true,
        leave: true,
        shift: pageSource == pageSourceCode.CALENDAR ? false : true,
        bank: pageSource == pageSourceCode.CALENDAR ? false : true
    });
    const [status, setStatus] = useState({
        opened: pageSource == pageSourceCode.CALENDAR ? false : true,
        closed: false,
        canceled: false,
        cancelationRequest: pageSource == pageSourceCode.CALENDAR ? false : true,
        pending: pageSource == pageSourceCode.CALENDAR ? true : false,
        approved: pageSource == pageSourceCode.CALENDAR ? true : false,
        refused: pageSource == pageSourceCode.CALENDAR ? true : false
    });
    const [typeRequestValue, setTypeRequestValue] = useState(null);
    const [statusValue, setStatusValue] = useState(null);
    const [isFirst, setIsFirst] = useState(false);    

    useEffect(() => {
        loadPage();
    }, [])

    useEffect(() => {
        handleTypeRequestValue();
    }, [typeRequest])

    useEffect(() => {
        handleStatusValue();
    }, [status])

    useEffect(() => {
        // Workaround to pass the right parameters after the changing status on the page load
        if (isFirst) {
            handleFilter([typeRequestValue, statusValue]);
        }
    }, [isFirst])

    const loadPage = async () => {
        await loadFilter();
        await handleStorageFilter();
        setIsFirst(true);
    }

    const loadFilter = async () => {

        const result = await getAllListsPage();
        let requestTypeList = result.requestTypeList;

        return new Promise(resolve => {

            let typeRequestItems = [];

            if (pageSource == pageSourceCode.CALENDAR) {
                requestTypeList = requestTypeList.filter(item => item.value != approvalType.SHIFT_EXCHANGE
                    && item.value != approvalType.BANK_ACCOUNT_CHANGE);
            }

            requestTypeList.forEach(item => {
                let typeRequestDesc = (IsEnglish() ? item.descriptionEn : item.descriptionFr).split('-')[1]?.trim();
                let typeRequestDescEn = item.descriptionEn.split(' ')[2].toLowerCase();
                typeRequestItems.push({ description: typeRequestDesc, key: typeRequestDescEn, value: item.value })
            });
            
            var listCentralFilter = [
                {
                    typeFilter: i18next.t("approvalCentral:filter.type-request"),
                    key: "typeRequest",
                    items: typeRequestItems
                },
                {
                    typeFilter: i18next.t("approvalCentral:filter.status-request"),
                    key: "status",
                    items: [
                        {
                            description: "Opened",
                            key: "opened",
                            value: centralApprovalStatus.OPENED
                        },
                        {
                            description: "Closed",
                            key: "closed",
                            value: centralApprovalStatus.CLOSE
                        },
                        {
                            description: "Canceled",
                            key: "canceled",
                            value: centralApprovalStatus.CANCELED
                        },
                        {
                            description: "Cancelation request",
                            key: "cancelationRequest",
                            value: centralApprovalStatus.CANCEL_REQUEST
                        }
                    ]
                }
            ];

            var listCalendarFilter = [
                {
                    typeFilter: i18next.t("approvalCentral:filter.type-request"),
                    key: "typeRequest",
                    items: typeRequestItems
                },
                {
                    typeFilter: i18next.t("approvalCentral:filter.status-request"),
                    key: "status",
                    items: [
                        {
                            description: "Pending",
                            key: "pending",
                            value: absenceCalendarStatus.PENDING
                        },
                        {
                            description: "Approved",
                            key: "approved",
                            value: absenceCalendarStatus.APPROVED
                        },
                        {
                            description: "Refused",
                            key: "refused",
                            value: absenceCalendarStatus.REFUSED
                        }
                    ]
                }
            ];

            setListFilter(pageSource == pageSourceCode.CALENDAR ? listCalendarFilter : listCentralFilter);
            resolve();
        })
    }

    const handleStorageFilter = () => {
        return new Promise(resolve => {
            const filter = storage.getFilter(pageSource);

            if (filter !== undefined) {
                setTypeRequest(filter.typeRequest);
                setStatus(filter.status);
            }

            resolve();
        });
    }

    const handleOpenFilter = () => {
        setOpen(true);
    }

    const handleFilterSubmit = () => {
        handleFilter([typeRequestValue, statusValue]);
        handleSaveStorageFilter();
        setOpen(false);
    }

    const handleTypeRequestValue = () => {

        const arrayValue = [];

        if (typeRequest.leave) {
            arrayValue.push(approvalType.LEAVE);
            arrayValue.push(approvalType.LEAVE_AZUR);
        }
        if (typeRequest.vacation) {
            arrayValue.push(approvalType.VACATION);
            arrayValue.push(approvalType.VACATION_AZUR);
        }
        if (typeRequest.shift) {
            arrayValue.push(approvalType.SHIFT_EXCHANGE);
        }
        if (typeRequest.bank) {
            arrayValue.push(approvalType.BANK_ACCOUNT_CHANGE);
        }

        setTypeRequestValue(arrayValue);
    }

    const handleStatusValue = () => {

        const arrayValue = [];

        if (pageSource == pageSourceCode.CALENDAR) {
            if (status.pending) {
                arrayValue.push(absenceCalendarStatus.PENDING);
            }
            if (status.approved) {
                arrayValue.push(absenceCalendarStatus.APPROVED);
            }
            if (status.refused) {
                arrayValue.push(absenceCalendarStatus.REFUSED);
            }
        } else {
            if (status.opened) {
                arrayValue.push(centralApprovalStatus.OPENED);
            }
            if (status.closed) {
                arrayValue.push(centralApprovalStatus.CLOSE);
            }
            if (status.canceled) {
                arrayValue.push(centralApprovalStatus.CANCELED);
            }
            if (status.cancelationRequest) {
                arrayValue.push(centralApprovalStatus.CANCEL_REQUEST);
            }
        }
        
        setStatusValue(arrayValue);
    }

    const getStatusStyle = (type, status) => {

        let statusStyle = '';
        
        if (type !== 'typeRequest'
            && pageSource == pageSourceCode.CALENDAR) {            
            switch (status) {
                case absenceCalendarStatus.PENDING:
                    statusStyle = classes.pending;
                    break;
                case absenceCalendarStatus.APPROVED:
                    statusStyle = classes.approved;
                    break;
                case absenceCalendarStatus.REFUSED:
                    statusStyle = classes.refused;
                    break;
            }
        }

        return statusStyle;
    }

    const handleSaveStorageFilter = () => {

        const filter = {
            typeRequest: typeRequest,
            status: status
        }

        storage.saveFilter(filter, pageSource);
    }

    const toggleDrawer = (open) => (event) => {

        // This is to avoid the drawer to close when we click within the filter div
        const role = event.currentTarget.attributes.role;

        if (role !== undefined && role.value === 'filter') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const listChild = (items, type) => {
        return (
            items.map((element, index) => (
                <FormControl key={index} className={styles.itemsFilter}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={(type === 'typeRequest' ? typeRequest[element.key] : status[element.key]) || false}
                                onChange={(event) => onChangeFilter(event, element.key, type)}
                                name={`filter-${element.key}`}
                                variant="success"
                            />
                        }
                        label={i18next.t(`approvalCentral:${type === 'typeRequest' ? "requestType" : "status"}.${element.key}`)}
                        classes={{
                            label: getStatusStyle(type, element.value)
                        }}
                        labelPlacement="end"
                    />
                </FormControl>
            )))
    }

    const list = (
        <div
            role="filter"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {listFilter.map((obj, index) => (
                <React.Fragment key={index}>
                    <List>
                        <ListItem>
                            <ListItemText primary={obj.typeFilter} />
                        </ListItem>
                    </List>

                    {listChild(obj.items, obj.key)}
                    <Divider />
                </React.Fragment>
            ))}
        </div>
    );

    const onChangeFilter = (event, key, typeFilter) => {
        if (typeFilter === 'typeRequest') {
            setTypeRequest({
                ...typeRequest,
                [key]: event.target.checked
            });
        }
        else {
            setStatus({
                ...status,
                [key]: event.target.checked
            });
        }
    }

    return (
        <div id="divFilterRequest">
            <React.Fragment>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar className={classes.toolBar}>
                        <Button startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="inherit" onClick={handleOpenFilter}>{i18next.t('approvalCentral:filter.button')}</Button>
                    </Toolbar>
                </AppBar>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)}>
                    {list}
                    <Button className={styles.buttonFilter} startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="primary" onClick={handleFilterSubmit}>{i18next.t('approvalCentral:filter.button')}</Button>
                </Drawer>
            </React.Fragment>
        </div>
    );
}

export default withNamespaces(['approvalCentral'], { wait: true })(FilterRequest);

FilterRequest.propTypes = {
    handleFilter: PropTypes.func.isRequired
}